import type { OfficialHomeLanguage } from './types';

/** 官网本地化营销内容结构；后续页面区块继续在这里按模块追加。 */
export interface OfficialHomeLocalizedContent {
  hero: {
    titleLines: Array<{
      prefix?: string;
      highlight?: string;
      suffix?: string;
    }>;
    description: string;
    action: string;
  };
  partnerLogos: {
    prefix: string;
    highlight: string;
  };
  caseList: {
    title: string;
    description: string;
  };
  capabilitiesOverview: {
    title: string;
    description: string;
  };
  feedbackOverview: {
    title: string;
    description: {
      prefix: string;
      highlight: string;
    };
  };
  pricing: {
    title: string;
    description: string;
  };
  startCreationBanner: {
    title: {
      prefix: string;
      highlight: string;
      suffix: string;
    };
    tryOnline: string;
    downloadMobile: string;
  };
}

/** 国内与海外官网共用一份本地化营销内容，语言选择仍由请求地区决定。 */
export const OFFICIAL_HOME_LOCALIZED_CONTENT: Record<OfficialHomeLanguage, OfficialHomeLocalizedContent> = {
  'zh-Hans': {
    hero: {
      // 中文首屏的渐变需覆盖完整主语，保持与视觉稿中的文字强调范围一致。
      titleLines: [{ highlight: '以IP为主角', suffix: '的AI创作平台' }],
      description: '让RoboNeo和角色一起成长，每天都有新故事，创作随时接着做。',
      action: '创建我的IP',
    },
    partnerLogos: {
      prefix: '携手',
      highlight: '20+ 世界级 AI 模型',
    },
    caseList: {
      title: '精选热门内容推荐',
      description: 'AI短剧、爆款复刻、短视频、表情包...多元创作工作流，让你的产出更丰富。',
    },
    capabilitiesOverview: {
      title: '看看RoboNeo能做什么',
      description: '从短剧、短视频、表情包到爆款复刻——围绕 IP 的完整创作能力矩阵',
    },
    feedbackOverview: {
      title: '600万+ 创作者的共同选择',
      description: {
        prefix: '他们喜欢 RoboNeo，',
        highlight: '你也会喜欢的',
      },
    },
    pricing: {
      title: '定价套餐',
      description: '选择适合你的套餐',
    },
    startCreationBanner: {
      title: {
        prefix: '你的',
        highlight: '创作',
        suffix: '，由此开启',
      },
      tryOnline: '在线体验',
      downloadMobile: '下载移App',
    },
  },
  en: {
    hero: {
      titleLines: [
        { highlight: 'Stunning visuals, effortless effects,' },
        { prefix: 'flawless execution.Create the next big hit.' },
      ],
      description: 'Your IP grows. Your content keeps up.',
      action: 'Start Your IP',
    },
    partnerLogos: {
      prefix: 'Partner with',
      highlight: '20+ world-class AI models',
    },
    caseList: {
      title: 'See What RoboNeo Can Do',
      description: 'The most extensive library of viral templates for AI video makers',
    },
    capabilitiesOverview: {
      title: 'Capabilities Overview',
      description: 'Everything you need to create viral content at scale',
    },
    feedbackOverview: {
      title: 'Trusted by 6M+ creators.',
      description: {
        prefix: 'They Love RoboNeo, ',
        highlight: 'you will too',
      },
    },
    pricing: {
      title: 'Pricing Plan',
      description: 'Select your Plan',
    },
    startCreationBanner: {
      title: {
        prefix: 'Start Your ',
        highlight: 'Creation',
        suffix: ' Now',
      },
      tryOnline: 'Try It Online',
      downloadMobile: 'Download Mobile App',
    },
  },
};
